import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MediaSelectionService } from '../../services/media-selection.service';
import { Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { DialogService } from '@mtgame/ui';
import { componentDestroyed, Game, MediaItem, UntilDestroy } from '@mtgame/core';

@UntilDestroy
@Component({
  selector: 'mtg-game-media-video',
  templateUrl: './game-media-video.component.html',
  styleUrls: ['./game-media-video.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GameMediaVideoComponent implements OnInit, OnDestroy {
  @Input()
  game: Game;
  @Input()
  video: MediaItem[];
  @Input()
  mediaRoute: string;
  selectEnabled: boolean;
  selectedImages: MediaItem[];

  constructor(
    private mediaSelectionService: MediaSelectionService,
    private router: Router,
    private dialogService: DialogService,
    private cdr: ChangeDetectorRef,
  ) {
  }

  ngOnInit(): void {
    this.mediaSelectionService.enabled$
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(enabled => {
        this.selectEnabled = enabled;
        this.cdr.markForCheck();
      });
    this.mediaSelectionService.selected$
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(selected => {
        this.selectedImages = selected;
        this.cdr.markForCheck();
      });
  }

  ngOnDestroy(): void {
  }

  trackById(index: number, item: MediaItem): number {
    return item.id;
  }

  toggleSelect(item: MediaItem): void {
    if (this.isSelect(item)) {
      this.mediaSelectionService.unselect(item);
    } else {
      this.mediaSelectionService.select(item);
    }
  }

  isSelect(item: MediaItem): boolean {
    return !!this.selectedImages.find(i => i.id === item.id);
  }
}
